/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarDiagnosticoCatalogoDto,
  CatalogoDiagnosticoResponse,
  CatalogoDiagnosticosControllerListarParams,
  CategoriasDeDiagnosticoResponse,
  CriarDiagnosticoCatalogoDto,
  ErroResponse,
  FundirDiagnosticoDto,
  PaginaDeCatalogoDiagnosticosResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCatalogoDiagnosticosControllerListarUrl = (params?: CatalogoDiagnosticosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/catalogo-diagnosticos?${stringifiedParams}` : `/v1/admin/catalogo-diagnosticos`
}

/**
 * @summary Lista o catálogo, paginado. A busca atravessa nome e sinônimos, sem acento — digitar "HAC" acha "Hiperadrenocorticismo".
 */
export const catalogoDiagnosticosControllerListar = async (params?: CatalogoDiagnosticosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCatalogoDiagnosticosResponse> => {

  return httpClient<PaginaDeCatalogoDiagnosticosResponse>(getCatalogoDiagnosticosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoDiagnosticosControllerListarQueryKey = (params?: CatalogoDiagnosticosControllerListarParams,) => {
    return [
    `/v1/admin/catalogo-diagnosticos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoDiagnosticosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError = ErroResponse>(params?: CatalogoDiagnosticosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoDiagnosticosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>> = ({ signal }) => catalogoDiagnosticosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoDiagnosticosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>>
export type CatalogoDiagnosticosControllerListarQueryError = ErroResponse


export function useCatalogoDiagnosticosControllerListar<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError = ErroResponse>(
 params: undefined |  CatalogoDiagnosticosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerListar<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoDiagnosticosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerListar<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoDiagnosticosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o catálogo, paginado. A busca atravessa nome e sinônimos, sem acento — digitar "HAC" acha "Hiperadrenocorticismo".
 */

export function useCatalogoDiagnosticosControllerListar<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoDiagnosticosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoDiagnosticosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoDiagnosticosControllerCriarUrl = () => {




  return `/v1/admin/catalogo-diagnosticos`
}

/**
 * @summary Cria um diagnóstico padronizado. O nome vai por extenso ("Hiperadrenocorticismo"); as siglas entram como sinônimo, que é o que a busca casa.
 */
export const catalogoDiagnosticosControllerCriar = async (criarDiagnosticoCatalogoDto: CriarDiagnosticoCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDiagnosticoResponse> => {

  return httpClient<CatalogoDiagnosticoResponse>(getCatalogoDiagnosticosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarDiagnosticoCatalogoDto)
  }
);}





export const getCatalogoDiagnosticosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>, TError,{data: CriarDiagnosticoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>, TError,{data: CriarDiagnosticoCatalogoDto}, TContext> => {

const mutationKey = ['catalogoDiagnosticosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>, {data: CriarDiagnosticoCatalogoDto}> = (props) => {
          const {data} = props ?? {};

          return  catalogoDiagnosticosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoDiagnosticosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>>
    export type CatalogoDiagnosticosControllerCriarMutationBody = CriarDiagnosticoCatalogoDto
    export type CatalogoDiagnosticosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um diagnóstico padronizado. O nome vai por extenso ("Hiperadrenocorticismo"); as siglas entram como sinônimo, que é o que a busca casa.
 */
export const useCatalogoDiagnosticosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>, TError,{data: CriarDiagnosticoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoDiagnosticosControllerCriar>>,
        TError,
        {data: CriarDiagnosticoCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoDiagnosticosControllerCriarMutationOptions(options), queryClient);
    }
    export const getCatalogoDiagnosticosControllerCategoriasUrl = () => {




  return `/v1/admin/catalogo-diagnosticos/categorias`
}

/**
 * @summary Categorias já em uso, para alimentar o filtro da tela
 */
export const catalogoDiagnosticosControllerCategorias = async ( options?: Parameters<typeof httpClient>[1]): Promise<CategoriasDeDiagnosticoResponse> => {

  return httpClient<CategoriasDeDiagnosticoResponse>(getCatalogoDiagnosticosControllerCategoriasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoDiagnosticosControllerCategoriasQueryKey = () => {
    return [
    `/v1/admin/catalogo-diagnosticos/categorias`
    ] as const;
    }


export const getCatalogoDiagnosticosControllerCategoriasQueryOptions = <TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoDiagnosticosControllerCategoriasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>> = ({ signal }) => catalogoDiagnosticosControllerCategorias({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoDiagnosticosControllerCategoriasQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>>
export type CatalogoDiagnosticosControllerCategoriasQueryError = unknown


export function useCatalogoDiagnosticosControllerCategorias<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerCategorias<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerCategorias<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Categorias já em uso, para alimentar o filtro da tela
 */

export function useCatalogoDiagnosticosControllerCategorias<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoDiagnosticosControllerCategoriasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoDiagnosticosControllerObterUrl = (id: string,) => {




  return `/v1/admin/catalogo-diagnosticos/${id}`
}

/**
 * @summary Detalha o diagnóstico do catálogo
 */
export const catalogoDiagnosticosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDiagnosticoResponse> => {

  return httpClient<CatalogoDiagnosticoResponse>(getCatalogoDiagnosticosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoDiagnosticosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/catalogo-diagnosticos/${id}`
    ] as const;
    }


export const getCatalogoDiagnosticosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoDiagnosticosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>> = ({ signal }) => catalogoDiagnosticosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoDiagnosticosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>>
export type CatalogoDiagnosticosControllerObterQueryError = ErroResponse


export function useCatalogoDiagnosticosControllerObter<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerObter<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoDiagnosticosControllerObter<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha o diagnóstico do catálogo
 */

export function useCatalogoDiagnosticosControllerObter<TData = Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoDiagnosticosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoDiagnosticosControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/catalogo-diagnosticos/${id}`
}

/**
 * @summary Atualiza o diagnóstico
 */
export const catalogoDiagnosticosControllerAtualizar = async (id: string,
    atualizarDiagnosticoCatalogoDto: AtualizarDiagnosticoCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDiagnosticoResponse> => {

  return httpClient<CatalogoDiagnosticoResponse>(getCatalogoDiagnosticosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarDiagnosticoCatalogoDto)
  }
);}





export const getCatalogoDiagnosticosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>, TError,{id: string;data: AtualizarDiagnosticoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>, TError,{id: string;data: AtualizarDiagnosticoCatalogoDto}, TContext> => {

const mutationKey = ['catalogoDiagnosticosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>, {id: string;data: AtualizarDiagnosticoCatalogoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoDiagnosticosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoDiagnosticosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>>
    export type CatalogoDiagnosticosControllerAtualizarMutationBody = AtualizarDiagnosticoCatalogoDto
    export type CatalogoDiagnosticosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Atualiza o diagnóstico
 */
export const useCatalogoDiagnosticosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>, TError,{id: string;data: AtualizarDiagnosticoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoDiagnosticosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarDiagnosticoCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoDiagnosticosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCatalogoDiagnosticosControllerDesativarUrl = (id: string,) => {




  return `/v1/admin/catalogo-diagnosticos/${id}`
}

/**
 * @summary DESATIVA — não apaga. Há diagnósticos de paciente apontando para cá, e o item continua sendo o que aquele animal recebeu. Responde com o item já desativado.
 */
export const catalogoDiagnosticosControllerDesativar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDiagnosticoResponse> => {

  return httpClient<CatalogoDiagnosticoResponse>(getCatalogoDiagnosticosControllerDesativarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCatalogoDiagnosticosControllerDesativarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogoDiagnosticosControllerDesativar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogoDiagnosticosControllerDesativar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoDiagnosticosControllerDesativarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>>

    export type CatalogoDiagnosticosControllerDesativarMutationError = ErroResponse

    /**
 * @summary DESATIVA — não apaga. Há diagnósticos de paciente apontando para cá, e o item continua sendo o que aquele animal recebeu. Responde com o item já desativado.
 */
export const useCatalogoDiagnosticosControllerDesativar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoDiagnosticosControllerDesativar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCatalogoDiagnosticosControllerDesativarMutationOptions(options), queryClient);
    }
    export const getCatalogoDiagnosticosControllerFundirUrl = (id: string,) => {




  return `/v1/admin/catalogo-diagnosticos/${id}/fundir`
}

/**
 * @summary Funde este diagnóstico em outro: aponta `substituidoPorId` e desativa. Os diagnósticos de paciente já registrados continuam apontando para o item antigo — é a LEITURA que segue a seta, porque repontá-los reescreveria o que o clínico escolheu na época.
 */
export const catalogoDiagnosticosControllerFundir = async (id: string,
    fundirDiagnosticoDto: FundirDiagnosticoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDiagnosticoResponse> => {

  return httpClient<CatalogoDiagnosticoResponse>(getCatalogoDiagnosticosControllerFundirUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fundirDiagnosticoDto)
  }
);}





export const getCatalogoDiagnosticosControllerFundirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>, TError,{id: string;data: FundirDiagnosticoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>, TError,{id: string;data: FundirDiagnosticoDto}, TContext> => {

const mutationKey = ['catalogoDiagnosticosControllerFundir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>, {id: string;data: FundirDiagnosticoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoDiagnosticosControllerFundir(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoDiagnosticosControllerFundirMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>>
    export type CatalogoDiagnosticosControllerFundirMutationBody = FundirDiagnosticoDto
    export type CatalogoDiagnosticosControllerFundirMutationError = ErroResponse

    /**
 * @summary Funde este diagnóstico em outro: aponta `substituidoPorId` e desativa. Os diagnósticos de paciente já registrados continuam apontando para o item antigo — é a LEITURA que segue a seta, porque repontá-los reescreveria o que o clínico escolheu na época.
 */
export const useCatalogoDiagnosticosControllerFundir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>, TError,{id: string;data: FundirDiagnosticoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoDiagnosticosControllerFundir>>,
        TError,
        {id: string;data: FundirDiagnosticoDto},
        TContext
      > => {
      return useMutation(getCatalogoDiagnosticosControllerFundirMutationOptions(options), queryClient);
    }
